<app-content-header i18n-title title="BL Keyword Details" i18n-subTitle
                    subTitle="Information about {{blKeywordId}}"
                    [backgroundImage]="backgroundImage"
                    [containerClass]="containerClass"
                    [subContainerClass]="subContainerClass"
                    [pyClass]="pyClass"
                    [contentClass]="contentClass"
                    [h1class]="h1class"
                    [h2class]="h2class"
                    [subContainerBackgroundImage]="subContainerBackgroundImage"
                    [containerBackgroundImage]="containerBackgroundImage"
                    *ngIf="blKeyword != null"
></app-content-header>

<app-content-breadcrumb [elements]="breadCrumbElements"></app-content-breadcrumb>

<div class="content">
  <div class="row">
    <div class="col-6 offset-3">
      <tripmakery-bl-keyword-info-bl-keyword-edit *ngIf="blKeyword != null" [pageBlKeyword]="blKeyword"></tripmakery-bl-keyword-info-bl-keyword-edit>
    </div>
  </div>
</div>

